import { useState, useEffect, useCallback } from "react";
import sellerGatewayApi from "@/services/api/SellerGateway";

export const useStoreGateways = (stores: any[]) => {
    const [gateways, setGateways] = useState<Record<string, any>>({});
    const [isLoading, setIsLoading] = useState(false);

    const fetchGateways = useCallback(async () => {
        if (!stores?.length) return;
        setIsLoading(true);

        const results = await Promise.allSettled(
            stores.map(store => sellerGatewayApi.findByStoreId(store.id))
        );

        const mapping: Record<string, any> = {};
        results.forEach((res, index) => {
            if (res.status === "fulfilled") {
                const data = res.value;
                const gateway = Array.isArray(data) ? data[0] : data;
                if (gateway?.idSeller) {
                    mapping[stores[index].id] = gateway;
                }
            }
        });

        setGateways(mapping);
        setIsLoading(false);
    }, [stores]);

    useEffect(() => {
        fetchGateways();
    }, [fetchGateways]);

    return { gateways, isLoading, refetch: fetchGateways };
};